import { FC } from 'react'
import { Card } from '@/common/card'

export const InsightCard: FC = ({ children }) => (
  <Card css={{ mb: '$12' }}>
    <div>{children}</div>
  </Card>
)
